var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Vue, Component, Prop, Watch, ModelSync } from 'vue-property-decorator';
import { BRow, BCol, BFormCheckbox, VBModal, BModal, BButton } from 'bootstrap-vue';
import axios from 'axios';
import debounce from 'lodash/debounce';
let FrameExtra = class FrameExtra extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.price = "0.00";
        this.validation = {
            isValid: true,
            problems: [],
            warnings: []
        };
        this.debouncedUpdate = debounce(this.update, 350);
    }
    get modalId() {
        return `${this.name.replace(/ /g, '-')}-info-modal`;
    }
    get queryParams() {
        return {
            width: this.dimensions.width,
            length: this.dimensions.length,
            sku: this.sku
        };
    }
    openModal() {
        this.$bvModal.show(this.modalId);
    }
    update() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            yield Promise.all([
                this.updatePrice(),
                this.validate()
            ]);
            this.loading = false;
        });
    }
    updatePrice() {
        return __awaiter(this, void 0, void 0, function* () {
            let { data } = yield axios
                .get(this.priceEndpoint, { params: this.queryParams });
            this.price = data.base_unit_price;
        });
    }
    validate() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.validationEndpoint) {
                let { data } = yield axios
                    .get(this.validationEndpoint, { params: this.queryParams });
                this.validation = data;
            }
        });
    }
    mounted() {
        this.update();
    }
};
__decorate([
    ModelSync('selected', 'change', { type: Boolean })
], FrameExtra.prototype, "extraSelected", void 0);
__decorate([
    Prop({ type: String })
], FrameExtra.prototype, "name", void 0);
__decorate([
    Prop({ type: Object })
], FrameExtra.prototype, "dimensions", void 0);
__decorate([
    Prop({ type: String })
], FrameExtra.prototype, "priceEndpoint", void 0);
__decorate([
    Prop({ type: String, default: null })
], FrameExtra.prototype, "validationEndpoint", void 0);
__decorate([
    Prop({ type: String, default: null })
], FrameExtra.prototype, "sku", void 0);
__decorate([
    Prop({ type: String, default: null })
], FrameExtra.prototype, "warning", void 0);
__decorate([
    Watch('dimensions', { deep: true })
], FrameExtra.prototype, "debouncedUpdate", void 0);
FrameExtra = __decorate([
    Component({
        components: {
            BRow, BCol, BFormCheckbox, BModal, BButton
        },
        directives: {
            'b-modal': VBModal
        }
    })
], FrameExtra);
export default FrameExtra;
